import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Tag } from "@models/tag";
import { deleteRequest, fetchRequest } from "@actions/tag";
import TagsTable from "@components/tags/Table";
import { Button, Card, Col, Input, Row, Modal } from "antd";
import TableRenderer from "@hocs/TableRenderer";
import { FormattedMessage } from "react-intl";
import SearchTagsComponent from "../../components/tags/Search";
import { NavLink } from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: Tag[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class TagsIndexPage extends React.Component<AllProps> {
  deleteTag = (item: Tag): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/tags/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.create_new_tag"
                defaultMessage={`Create Tag`}
              />
            </Button>
          </NavLink>
        </div>

        <div className={"page-table-wrapper"}>
          <Card className={`page-table-header`} bordered={false}>
            <SearchTagsComponent search={search} />
          </Card>

          <TagsTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteTag}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ tags }: ApplicationState) => ({
  loading: tags.loading,
  errors: tags.errors,
  data: tags.data,
  count: tags.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(TagsIndexPage));
